<template>
  <div class="huise ding pins">
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <van-sticky>
      <van-tabs v-model="courseClassify">
        <van-tab
          v-for="list in tab"
          :key="list.name"
          :title="list.title"
          :name="list.name"
        ></van-tab>
      </van-tabs>
      <!-- <div class="baisuid">
        <span
          @click="onClick(list.name)"
          class="yansex mohjui"
          :class="courseClassify == list.name ? 'daziti' : ''"
          v-for="list in tab"
          :key="list.title"
          >{{ list.title }}</span
        >
      </div> -->
    </van-sticky>
    <div class="shangxia" v-if="courseClassify == '0'">
      <div class="di">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item
            class="yuhujf"
            v-for="list in imglist"
            :key="list.advId"
            @click="tiao(list.advUrl)"
          >
            <img :src="list.advImg" width="100%" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="pin" v-if="courseClassify == '0'">
      <div class="mag">
        <img class="xiaoimg" src="../assets/img/z.png" width="15px" />
        <span class="heis">最新直播</span
        ><span class="xiaosoan">以爱育爱 以慧启慧</span>
      </div>
      <!-- <span class="spanhui">最新直播</span> -->
      <!-- <span class="wujis">({{ zhiboshij }})</span> -->
    </div>
    <van-empty
      class="custom-image"
      :class="courseClassify == 0 ? 'imgsffa' : ''"
      :image="img"
      v-if="courlist.length == 0"
      description="暂时没有数据"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pin">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="木有更多了~"
        @load="onLoad"
        class="bai di mtop"
        v-if="courlist.length > 0"
      >
        <div style="height: 1px; margin-top: -11px"></div>
        <div
          class="pin1 ditus dichu"
          v-for="(list, index) in courlist"
          :key="index"
          @click="dianjis(list.lessonId)"
        >
          <van-row>
            <van-col span="16">
              <van-col span="24" class="heise">{{ list.courseName }}</van-col>
              <van-col span="24">
                <span class="lanm biao-span" v-if="list.classifyName">{{
                  list.classifyName
                }}</span>
                <!-- <span class="hongmu biao-span" v-if="list.classifyName">{{list.classifyName }}</span> -->
              </van-col>
            </van-col>
            <van-col span="8">
              <van-col span="24" class="magtop" style="text-align: right">
                <span v-if="list.liveStatus == '1'" class="jinru"
                  >进入直播</span
                >
                <span v-if="list.liveStatus == '2'" class="wei">未开始</span>
                <span v-if="list.liveStatus == '3'" class="jieshu"
                  >直播结束</span
                >
                <span v-if="list.liveStatus == '4'" class="jinru"
                  >查看回放</span
                >
                <!-- <span class="daanniu">进入直播</span> -->
              </van-col>
            </van-col>
            <van-col span="24">
              <van-col span="15" class="spanhong">
                <span>{{ yue(list.beginTime) }}</span>
                <span>{{ getWeekDay(list.beginTime) }}</span>
                <span>{{ slice(list.beginTime, list.endTime) }}</span>
              </van-col>
              <!-- <van-col span="9" class="huisezi">
                {{
                  list.lessonViewnum > 10000
                    ? yuetu(list.lessonViewnum)
                    : list.lessonViewnum
                }}观看
                {{
                  list.lessonZannum > 10000
                    ? yuetu(list.lessonZannum)
                    : list.lessonZannum
                }}点赞
              </van-col> -->
            </van-col>
          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import {
  courseonlinelist,
  courseclassify,
  advlist,
  getShareInfo,
  userwxlogin
} from "@/api/home";
import wx from "weixin-js-sdk";
import dibu from "@/components/index/di";
import { Toast } from "vant";
export default {
  data() {
    return {
      tab: [],
      active: 0,
      subjec: [],
      curPage: 1,
      pageSize: 10,
      courlist: [],
      loading: true,
      year: "",
      month: "",
      courseClassify: "0",
      Page: [],
      tablist: [],
      loading: false,
      finished: false,
      img: require("../assets/img/kong.png"),
      show: false,
      imglist: [],
      refreshing: false,
      isLoading: false,
      zhiboshij: "",
      beginDate: "",
      endDate: "",
    };
  },
  watch: {
    courseClassify() {
      this.courlist = [];
      this.curPage = 1;
      this.finished = false;
      this.courseonlinelist();
    },
  },
  components: {dibu},
  methods: {
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.courlist = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.curPage = 1;
      this.courseonlinelist();
    },
    onLoad() {
      this.curPage++;
      this.courseonlinelist();
    },
    courseonlinelist() {
      let that = this;
      let params = {};
      if (this.courseClassify == "0") {
        params = {
          // courseTypeid: 1,
          roomTypes: 3,
          courseState: 1,
          curPage: this.curPage,
          pageSize: 10,
          endDate: this.endDate,
          beginDate: this.beginDate,
          groupId:1,
        };
      } else {
        params = {
          // courseTypeid: 1,
          roomTypes: 3,
          courseState: 1,
          courseClassify: this.courseClassify,
          curPage: this.curPage,
          pageSize: 10,
          groupId:1,
        };
      }
      that.loading = true;
      courseonlinelist(params)
        .then((res) => {
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            that.courlist.push(res.data.data.dataList[i]);
          }
          that.loading = false;
          if (that.courlist.length >= res.data.data.totalCount) {
            that.finished = true;
          }
          that.isLoading = false;
          that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    getWeekDay(dateString) {
      dateString = dateString.slice(0, 10);
      var dateArray = dateString.split("-");
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },
    slice(s, d) {
      if(s&&d){
        return false
      }
      return s.slice(10, 16) + " -" + d.slice(10, 16);
    },
    yue(s) {
      return s.slice(5, 11);
    },
    dianjis(s) {
      this.$router.push({
        path: "/video",
        query: {
          id: s,
          t: Date.now()
        },
      });
    },
    courseclassi() {
      let that = this;
      that.show = true;
      courseclassify({
        classifyLevel: 1
      })
        .then((res) => {
          that.list = res.data.data;
          let tab = [{ title: "全部", name: "0" }];
          for (var i = 0; i < res.data.data.length; i++) {
            let list = {
              title: res.data.data[i].classifyName,
              name: res.data.data[i].id,
            };
            tab.push(list);
          }
          that.tab = tab;
          that.courseonlinelist();
          that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    advlist() {
      let that = this;
      let params = {
        schoolId: 0,
        apCode: "302",
      };
      advlist(params)
        .then((res) => {
          that.imglist = res.data.data;
        })
        .catch(() => {});
    },
    tiao(s) {
      if (s) {
        window.location.href = s;
      }
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    getShareInfo() {
      //如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
      var params = {
        //请求参数
        url: window.location.href.split("#")[0],
      };
      let tit = "测试分享";
      let fxUrl = window.location.href;
      getShareInfo(params).then((res) => {
        let appId = res.data.data.appid;
        let timestamp = res.data.data.timestamp;
        let nonceStr = res.data.data.noncestr;
        let signature = res.data.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识，填自己的！
          timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: [
            "onMenuShareTimeline", // 分享到朋友圈
            "onMenuShareAppMessage", // 分享到微信好友
          ],
        });

        wx.ready(function () {
          //分享给朋友
          wx.onMenuShareAppMessage({
            title: "爱慧师苑-直播平台", // 分享标题
            desc: "爱慧师苑-直播平台", // 分享描述
            link: fxUrl, // 分享链接
            imgUrl:
              "https://file.welaiedu.cn/Icon/W0W6OTgXOH.png", // 分享图标
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });

          wx.onMenuShareTimeline({
            title: "爱慧师苑-直播平台", // 分享标题
            link: fxUrl, // 分享链接
            imgUrl:
              "https://file.welaiedu.cn/Icon/W0W6OTgXOH.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });
        });

        wx.error(function (res) {
          // alert(res.errMsg);
        });
      });
    },
    yuetu(s) {
      s = s / 10000;
      s = s.toFixed(2);
      return s + "万";
    },
  },
  mounted() {
    var now = new Date(); // 当前日期
    var nowDayOfWeek = now.getDay(); // 今天本周的第几天
    var nowDay = now.getDate(); // 当前日
    var nowMonth = now.getMonth(); // 当前月
    var nowYear = now.getYear(); // 当前年
    nowYear += nowYear < 2000 ? 1900 : 0;
    var day = nowDayOfWeek || 7;
    this.beginDate = this.formatDate(
      new Date(now.getFullYear(), nowMonth, nowDay + 1 - day)
    );
    this.endDate = this.formatDate(
      new Date(now.getFullYear(), nowMonth, nowDay + 7 - day)
    );
    this.beginDate = this.beginDate.replace(/\//i, "-");
    this.endDate = this.endDate.replace(/\//i, "-");
    this.zhiboshij = this.beginDate + "至" + this.endDate;
    // this.getCode()
    this.courseclassi();
    this.advlist();
    // this.getShareInfo();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index.vue